import { useState, useEffect } from 'react';
import { Plus, X } from 'lucide-react';
import AddAgentDialog from './AddAgentDialog';

const AgentSearchSelect = ({
  label,
  value,
  onChange,
  onAgentCreated,
  placeholder,
  agents: agentsProp = [],
  companyKey = "",
}) => {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [agents, setAgents] = useState(agentsProp);

  // Sync agent list when prop updates
  useEffect(() => {
    setAgents(agentsProp);
  }, [agentsProp]);

  // Resolve selected agent from the agents list by id
  useEffect(() => {
    if (!value) {
      setSelectedAgent(null);
      return;
    }
    const found = agents.find((a) => String(a.id) === String(value));
    setSelectedAgent(found || null);
  }, [value, agents]);

  const handleClear = () => {
    onChange(null);
    setSelectedAgent(null);
  };

  const handleAgentAdded = (newAgent) => {
    setAgents((prev) => [...prev, newAgent]);
    setSelectedAgent(newAgent);
    onChange(newAgent.id);
    onAgentCreated?.(newAgent);
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>

      {selectedAgent ? (
        <div className="flex h-10 w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm mb-4">
          <span className="truncate">
            {selectedAgent.first_name} {selectedAgent.last_name} - {selectedAgent.agency || selectedAgent.email}
          </span>
          <button
            onClick={handleClear}
            className="ml-2 p-1 hover:bg-gray-200 rounded-full"
            type="button"
          >
            <X className="h-4 w-4 text-gray-500" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setIsAddDialogOpen(true)}
          className="flex items-center gap-2 h-10 w-full justify-center rounded-md border border-[#239D80] bg-white px-3 py-2 text-sm text-[#239D80] hover:bg-[#239D80]/10 transition-colors mb-4"
        >
          <Plus className="h-4 w-4" />
          Add Agent
        </button>
      )}

      <AddAgentDialog
        open={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        onAgentAdded={handleAgentAdded}
        agents={agents}
        companyKey={companyKey}
      />
    </div>
  );
};

export default AgentSearchSelect;
